import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCurveEasing20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconCurveEasing20"
            aria-hidden="true"
            {...props}
        >
            <g fill="currentColor">
                <path d="M14.25 6.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M15 8.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m.042 3a.75.75 0 0 0-1.5 0 1.75 1.75 0 0 1-1.75 1.75H5.75a.75.75 0 0 0 0 1.5h6.042a3.25 3.25 0 0 0 3.25-3.25" />
                <path
                    fillRule="evenodd"
                    d="M2 4.5A2.5 2.5 0 0 1 4.5 2h11A2.5 2.5 0 0 1 18 4.5v11a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 15.5zm2.5-1h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1"
                    clipRule="evenodd"
                />
            </g>
        </svg>
    );
}
export default memo(IconCurveEasing20);
